import React, { useRef, useState } from "react";
// import { styled } from "@mui/material/styles";
import styled from "styled-components";
import Button, { ButtonProps } from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import classNames from "classnames";
import { InputFieldCss } from "./inputFieldContainer";

const VisuallyHiddenInput = styled.input`
  display: none;
`;
const CustomButton = styled(Button)<ButtonProps>`
  && {
    max-width: 110px;
    width: 100%;
    text-transform: capitalize;
    color: #f2f2f2;
    font-family: "Plus Jakarta Sans", sans-serif;
    background-color: #00a4e5 !important;
    &:hover {
      background-color: #0582c0 !important;
    }
    padding: 6px 8px !important;
    font-weight: 400;
  }
`;
interface InputFileUploadProps {
  name: string;
  id?: string;
  placeholder?: string;
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  labelName?: string;
  required?: boolean;
  register?: any;
  errors?: any;
  acceptTypes: string[];
  [key: string]: any;
}

export default function InputFileUpload({
  name,
  className,
  labelName,
  required,
  register,
  errors,
  acceptTypes,
}: InputFileUploadProps) {
  const inputClasses = classNames(
    "form-control",
    "form-control-sm",
    "m-input",
    "search-icons",
    className
  );
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [exceedSizeLimit, setExceedSizeLimit] = useState<boolean>(false);
  const [notFileType, setNotFileType] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e:any) => {
    // console.log("handleFileChange", e);
    const file = e.target.files[0];
    if (!file) return;
    var fileName = file.name.toLowerCase();
    const isValidFileType = new RegExp(
      `\\.(${acceptTypes.join("|")})$`,
      "i"
    ).test(fileName);

    if (!isValidFileType) {
      setNotFileType(true);
      return false;
    }
    if (file && file.size > 10 * 1024 * 1024) {
      // File size greater than 10 MB
      setExceedSizeLimit(true);
      setNotFileType(false);
      setSelectedFile(null);
    } else {
      setExceedSizeLimit(false);
      setSelectedFile(file);
      setNotFileType(false);
      register?.(name)?.onChange(e);
    }
  };

  const handleSpanClick = () => {
    fileInputRef.current?.click(); // Trigger the file input click event
  };
  return (
    <InputFieldCss>
      <div className="form-group">
        {labelName && (
          <label className="input__textfield">
            {labelName}
            {required && <span className="common__required">*</span>}
          </label>
        )}
        <div className="common__upload_button">
          <span
            style={{ width: "100%", marginRight: "5px" }}
            className="form-control form-control-sm m-input search-icons common__upload_span"
            onClick={handleSpanClick}
          >
            {selectedFile ? selectedFile.name : "No file chosen"}
          </span>
          <CustomButton
            component="label"
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            // ref={fileInputRef}
          >
            Upload file
            <VisuallyHiddenInput
              type="file"
              name={name}
              className={inputClasses}
              accept={acceptTypes.map((type) => `.${type}`).join(",")}
              {...register(name, { required: true })}
              onChange={handleFileChange}
            />
          </CustomButton>
        </div>
        <div className="d-flex flex-column">
          <span className="common__format common__span">
            Accepted formats: JPG,JPEG,PNG,PDF
          </span>
          {errors && (
            <span className="common__inputField__error common__span">
              The {name} is required.
            </span>
          )}
          {exceedSizeLimit && (
            <span className="common__inputField__error common__span">
              File size exceeds the limit of 10 MB.
            </span>
          )}
          {notFileType && (
            <span className="common__inputField__error common__span">
              You can upload jpg, jpeg, png and pdf files only.
            </span>
          )}
        </div>
      </div>
    </InputFieldCss>
  );
}
